import * as yup from 'yup';
import { TFunction } from 'i18next';
import { VALUATION_METHODS } from '../constants';

const getValidationSchema = (t: TFunction) =>
  yup.object().shape({
    valuationMethod: yup.string().required(),
    daysBack: yup.number().when('valuationMethod', {
      is: VALUATION_METHODS.DAILY_WEIGHTED_AVERAGE,
      then: (schema) =>
        schema
          .required(t('inventory.inventoryValuationSettings.daysBackRequired'))
          .min(1, t('inventory.inventoryValuationSettings.daysBackMinError'))
          .max(1000, t('inventory.inventoryValuationSettings.daysBackMaxError')),
      otherwise: (schema) => schema.notRequired(),
    }),
    calendarType: yup.string().when('valuationMethod', {
      is: VALUATION_METHODS.MONTHLY_WEIGHTED_AVERAGE,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired(),
    }),
    quarterStyle: yup.string().notRequired(),
  });

export default getValidationSchema;
